<template>
	<div v-if="project">
		<v-layout row>
			<v-flex>
				<v-card style="margin: 10px">
					<v-card-title class="grey darken-3 white--text">
						<h3>{{'Sprawozdanie końcowe' + getHeaderSuffix()}}</h3>
					</v-card-title>
					<v-card-text>
						<display-text-component v-if="project.title"
							label="Nazwa projektu"
							:value="project.title"/>
						<display-text-component v-if="project.projectCode"
							label="Numer projektu"
							:value="project.projectCode"/>
						<display-text-component v-if="project.projectStartDate && project.projectEndDate"
							label="Okres realizacji projektu"
							:value="project.projectStartDate + ' - ' + project.projectEndDate"/>
						<display-text-component v-if="project.mainBidder && project.mainBidder.id"
							label="Nazwa wykonawcy"
							:value="mainBidderName"/>
						<display-text-component v-for="(mutualBidderName, index) in mutualBiddersNames" :key="index"
							:label="project.mutualBidders.length === 1 ? 'Nazwa współwykonawcy' : ('Nazwa współwykonawcy ' + (index + 1))"
							:value="mutualBidderName"/>
						<display-text-component v-if="project.projectCode"
							label="Numer umowy"
							:value="project.projectCode"/>
						<display-text-component v-if="project.agreementSignDate"
							label="Data zawarcia umowy"
							:value="project.agreementSignDate"/>
						<display-text-component v-if="project.annexNumber"
							label="Numer aneksu"
							:value="project.annexNumber"/>
						<display-text-component v-if="project.annexSignDate"
							label="Data podpisania aneksu"
							:value="project.annexSignDate"/>
						<display-text-component v-if="project.ownContribution"
							label="Zatwierdzony wkład własny"
							:value="formatMoneyWithCode(project.ownContribution,'PLN')"/>
						<display-text-component v-if="project.approvedDonation"
							label="Zatwierdzona kwota dotacji"
							:value="formatMoneyWithCode(project.approvedDonation,'PLN')"/>
						<display-text-component v-if="sendDate"
							label="Data wysłania sprawozdania"
							:value="sendDate"/>
						<display-text-component v-if="approvalDate"
							label="Data zatwierdzenia sprawozdania"
							:value="approvalDate"/>
						<display-text-component v-if="reportData.controlSum"
							label="Suma kontrolna"
							:value="reportData.controlSum"/>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import DisplayTextComponent from "../offer/components/DisplayTextComponent";
	import {Numbers} from "@/utils/Numbers";
  import {Bidder} from "@/api/generated/Bidder";

	export default {
		name: 'final-report-header',
		components: {DisplayTextComponent},

		data() {
			return {
        mainBidderName: '',
        mutualBiddersNames: [],
				sendDate: null,
				approvalDate: null
			};
		},

		props: {
			showApprovedHeader: {type: Boolean, default: false},
			project: null,
			reportData: null
		},

    mounted() {
      Bidder.getOriginalProjectDetails(this, this.project.mainBidder.id, this.$route.params.projectId, successResponse => {
        this.mainBidderName = successResponse.polishName;
      }, errorResponse => {
        this.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
      });

      this.project.mutualBidders.forEach(bidder => {
        Bidder.getOriginalProjectDetails(this, bidder.id, this.$route.params.projectId, successResponse => {
          this.mutualBiddersNames.push(successResponse.polishName);
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
        });
      });
    },

		methods: {
			getHeaderSuffix() {
				return this.showApprovedHeader ? " - zatwierdzone" : "";
			}
		},

		mixins: [
			Numbers
		]
	};
</script>
